<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20">
        <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="info.headImg" v-if="info.headImg" :preview-src-list="[info.headImg]"></el-image>
        <img style="width: 50px; height: 50px;" src="@/assets/du_logo.png" v-else />
        <div class="ml10 flex-col">
          <div class="flexs">
            <span class="font16">{{info.customerName}}</span>
            <div class="font12 label-box ml5" v-if="info.customerLevelName">{{info.customerLevelName}}</div>
          </div>
          <div class="flexs mt5 ">
            <div v-if="info.customerTagList && info.customerTagList.length" class="flexs font12 ">
              <div class="label-boxs " v-for="item in info.customerTagList" :key="item.id">{{item.name}}</div>
            </div>
            <!-- <i class="el-icon-edit ml5 c-main" ></i> -->
          </div>
        </div>
      </div>
      <div>
        <el-descriptions title="" direction="vertical" :column="8" :colon="false">
          <el-descriptions-item label="电话" label-class-name="c-8F8E8E">{{info.customerPhone}}</el-descriptions-item>
          <el-descriptions-item label="邀请业务员" label-class-name="c-8F8E8E">{{info.inviteName}}</el-descriptions-item>
          <el-descriptions-item label="邀请业务员电话" label-class-name="c-8F8E8E">{{info.invitePho}}</el-descriptions-item>
          <el-descriptions-item label="所在区域" label-class-name="c-8F8E8E">{{info.provinceName}}{{info.cityName}}{{info.regionName}}</el-descriptions-item>
          <el-descriptions-item label="意向度" label-class-name="c-8F8E8E">{{info.intentionality==1?'高':info.intentionality==2?'中':info.intentionality==3?'低':'无'}}</el-descriptions-item>
          <el-descriptions-item label="线索来源" label-class-name="c-8F8E8E">{{info.dataSource==1?'名片':info.dataSource==2?'APP业务录入':'后台录入'}}</el-descriptions-item>
          <el-descriptions-item label="加入线索时间" label-class-name="c-8F8E8E">{{info.createdTime}}</el-descriptions-item>
          <el-descriptions-item label="绑定业务员" label-class-name="c-8F8E8E" v-if="info.ywName">{{info.ywName}}({{setLevel(info.ywLevelId)}}){{info.ywPho}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <el-tabs v-model="activeName" @tab-click="" class="mt20">
        <el-tab-pane label="基础信息" name="1"></el-tab-pane>
        <el-tab-pane label="跟进情况" name="2"></el-tab-pane>
      </el-tabs>
      <template v-if="activeName==1">
        <Title class="mt20">基础信息</Title>
        <el-descriptions title="">
          <el-descriptions-item label="门店类型">{{info.companyType}}</el-descriptions-item>
          <el-descriptions-item label="日均门诊量">{{info.dailyOutpatientVisits}}</el-descriptions-item>
          <el-descriptions-item label="员工数量">{{info.staffNum}}</el-descriptions-item>
          <el-descriptions-item label="正在开展项目">{{info.projectId}}</el-descriptions-item>
          <el-descriptions-item label="微信号">{{info.wechatNumber || '无'}}</el-descriptions-item>
          <el-descriptions-item label="修改时间">{{info.operatedTime}}</el-descriptions-item>
          <el-descriptions-item label="备注">{{info.remark || '无'}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==2">
        <div class="mb20 font14 " v-if="list.length">下次跟进时间：{{list[0].nextFollowUpTime}}</div>
        <el-timeline reverse v-if="list.length">
          <el-timeline-item v-for="(item, index) in list" :key="index" type="primary">
            <div class="boxs">
              <div class="flexs justify-between mb10">
                <span>{{item.followUpTitle}}</span>
                <span class="c-8F8E8E">{{item.createdTime.split(' ')[0]}} 星期{{setWeek(dayjs(item.createdTime).day())}}</span>
              </div>
              <span class="c-8F8E8E">跟进内容：{{item.followUpContent}}</span>
              <div class="flexs mt10" v-if="item.followUpUrl">
                <el-image style="width: 50px; height: 50px;border-radius: 4px;" class="mr10" :src="it" :preview-src-list="[item.followUpUrlList]" v-for="(it,indexs) in item.followUpUrlList" :key="indexs"></el-image>
              </div>
              <div class="mt10 c-8F8E8E">跟进时间：{{item.createdTime}}</div>
              <div class="mt10 c-8F8E8E">下次跟进时间：{{item.nextFollowUpTime}}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <Empty v-if="!list.length">该线索暂无跟进信息～</Empty>
      </template>
    </el-card>
  </div>
</template>

<script>
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
import userApi from '@/api/user'
export default {
  props: ['rowId'],
  data() {
    return {
      info: {
        customer: {},
        customerUserPO: {},
        customerLevel: {},
        customerCertificates: {},
        line: {},
        technicianInfo: {},
        userWallet: {}
      },
      listLoading: true,
      list: [],
      query: {
        pageNo: 1,
        pageSize: 10,
        customerType: 3,
        isOpenSea: 0
      },
      businessStanding: [],
      customerLine: '',
      activeName: '1',
    }
  },
  computed: {
    setLevel() {
      return function (val) {
        if (val) {
          // console.log('this.businessStanding.find(i=>i.level==val): ',this.businessStanding,val);
          return this.businessStanding.find(i => i.level == val).name
        } else {
          return
        }
      }
    },
    setWeek() {
      return function (val) {
        switch (val) {
          case 1:
            return "一";
            break;
          case 2:
            return "二";
            break;
          case 3:
            return "三";
            break;
          case 4:
            return "四";
            break;
          case 5:
            return "五";
            break;
          case 6:
            return "六";
            break;
          case 0:
            return "日";
            break;
        }
      }

    }
  },
  async created() {
    await this.getBusinessStanding()
    this.getDetail()
    this.getList()
  },
  methods: {
    async getDetail() {
      const {
        data
      } = await userApi.fetchById(this.rowId)
      this.info = data
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.businessStanding = data
        console.log('客户身份: ', data);
      })
    },
    async getList() {
      const {
        data
      } = await userApi.followUpRecord({
        clueId: this.rowId
      })
      // console.log('进度: ',data);
      this.list = data.list.map(item => {
        if (item.followUpUrl) {
          item.followUpUrlList = item.followUpUrl.split(',')
        }
        return item
      }).reverse()
    }
  }

}
</script>

<style lang="scss" scoped>
a:hover {
  color: #60b7dc;
}

.boxs {
  width: 97%;
  padding: 20px;
  box-shadow: 0px 0px 4px 0px #00000040;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.label-boxs {
  background: #c8ab0e1a;
  padding: 2px 4px;
  border-radius: 2px;
  color: #c8ab0e;
  margin-right: 5px;
}

.step-box {
  width: 160px;
  height: 44px;
  margin-right: 10px;

  ::v-deep .el-image {
    width: 160px;
    height: 44px;
  }

  div {
    left: 0;
    top: 0;
  }
}

::v-deep.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 14px;
}
</style>
